// extracted by mini-css-extract-plugin
module.exports = {"rcw-conversation-container":"chat_rcw-conversation-container__2PLH-","rcw-header":"chat_rcw-header__btMV0"};